import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { purchaseActivity, activityToneStyles } from '../../data/liveActivity';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 9000;

/**
 * Aviso emergente de compras recientes, abajo a la izquierda.
 */
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % purchaseActivity.length);
      }, VISIBLE_MS);
    }, visible ? 0 : index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, dismissed]);
  const item = purchaseActivity[index];
  const tone = activityToneStyles[item.tone];
  return <AnimatePresence data-id="element-164" data-mp="2img1wja3ecvg">
      {visible && !dismissed ? <motion.div key={item.id} initial={{
      opacity: 0,
      x: -40,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -30
    }} transition={{
      duration: 0.45,
      ease: [0.16, 1, 0.3, 1]
    }} role="status" aria-live="polite" className="fixed bottom-5 left-5 z-[900] flex w-[300px] items-center gap-3 rounded-2xl border-2 border-line bg-white p-3 shadow-brand-lg" data-id="element-165" data-mp="2downnjdea03i">
          <span className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full font-display text-xs font-extrabold ${tone.avatar}`} data-id="element-166" data-mp="3afp3qh0bvs5a">
            {item.initials}
          </span>
          <p className="text-[12px] leading-snug text-ink" data-id="element-167" data-mp="3dicubbplh2bg">
            <span className="font-bold text-brand-blue" data-id="element-168" data-mp="3dfqmrc2pemt8">{item.name}</span>
            <span className="text-muted" data-id="element-169" data-mp="3igxvbdco7q0y"> · {item.location}</span>
            <br data-id="element-170" data-mp="3nfhkrnqh3jy2" />
            acaba de contratar el{' '}
            <span className={`font-bold ${tone.pkg}`} data-id="element-171" data-mp="3ndwlxlx4leue">{item.packageName}</span>
            <br data-id="element-172" data-mp="3s7siql1nkvnz" />
            <span className="inline-flex items-center gap-1 text-[10px] text-muted" data-id="element-173" data-mp="3s8ap4ai14q9m">
              <CheckCircleIcon sx={{
            fontSize: 12
          }} className="text-brand-green" data-id="element-174" data-mp="4rmo52g08r9" />
              Compra verificada · {item.timeAgo}
            </span>
          </p>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-muted transition hover:bg-line hover:text-ink" data-id="element-175" data-mp="9z0dmobtrtnb">
            <CloseIcon sx={{
          fontSize: 14
        }} data-id="element-176" data-mp="2gtf0bvpo58fc" />
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}